var version = {
    "name":      "dativery",
    "buildDateCode": "20251212-191908",
    "buildDate": "Fri Dec 12 2025 19:19:08 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251212-191908",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;